import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGift } from "@fortawesome/free-solid-svg-icons";
import BadgePercent from "../../assets/icons/badge-percent.png";
import { Link } from "react-router-dom";
import FallbackImg from "../FallbackImg";

const HomeBarSub2 = ({ product }) => {
  const isLoggedIn = !!localStorage.getItem("access_token");

  let mainPrice, oldPrice, discountPercent, showOldPrice, showDiscount;
  // prefer backend discount fields when present
  const backendBP =
    product.discount_percent_bp || product.discount_percent || "";
  const backendRCP =
    product.discount_percent_rcp || product.display_discount_pct || "";

  const formatCurrency = (value) => {
    return parseFloat(value).toLocaleString("en-MY", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  // parse numeric values safely (handles 'xxxx.xx' or non-numeric)
  const toNumber = (v) => {
    if (v === undefined || v === null) return null;
    const n = parseFloat(v);
    return Number.isFinite(n) ? n : null;
  };

  const lowestNum = toNumber(product.lowest_price);
  const highestNum = toNumber(product.highest_price);
  const brandNum = toNumber(product.brand_price);
  const brandOfferNum = toNumber(product.brand_price_offer);
  const rcpNum = toNumber(product.rcp);

  const isPriceRange =
    lowestNum !== null && highestNum !== null && highestNum > lowestNum;

  // Decide display price prioritizing lowest -> offer -> brand -> rcp
  if (isPriceRange && isLoggedIn) {
    // range: display range as main price; allow backend discount badge if provided
    showOldPrice = false;
    mainPrice = lowestNum;
    const discountDisplay = backendBP || backendRCP || null;
    const normalizedDiscount =
      discountDisplay && String(discountDisplay).trim() !== "0%"
        ? discountDisplay
        : null;
    showDiscount = !!normalizedDiscount;
    discountPercent = normalizedDiscount;
    // we'll format range later using lowestNum and highestNum
  } else {
    // single price: choose the most appropriate numeric value regardless of login
    const chosen =
      (lowestNum !== null && lowestNum > 0 && lowestNum) ||
      (brandOfferNum !== null && brandOfferNum > 0 && brandOfferNum) ||
      (brandNum !== null && brandNum > 0 && brandNum) ||
      (rcpNum !== null && rcpNum > 0 && rcpNum) ||
      null;

    mainPrice = chosen;

    // compute old price & discount when we have a brandNum larger than chosen
    if (brandNum !== null && chosen !== null && brandNum > chosen) {
      oldPrice = brandNum;
      const calculatedDiscount = Math.round(
        ((brandNum - chosen) / brandNum) * 100,
      );
      discountPercent =
        calculatedDiscount > 0 ? `-${calculatedDiscount}%` : null;
      showOldPrice = calculatedDiscount > 0;
      showDiscount = calculatedDiscount > 0;
    } else {
      oldPrice = null;
      discountPercent = null;
      showOldPrice = false;
      showDiscount = false;
    }
  }

  // Detect package items (IDs like 'is_package_*', bundle flags, or promo_name 'Package')
  const isPackage =
    (typeof product.item_id === "string" &&
      product.item_id.startsWith("is_package_")) ||
    (product.bundle_id && String(product.bundle_id).includes("is_bundle")) ||
    (product.promo_name && /package/i.test(product.promo_name));

  // For packages without numeric prices, render with 'xxxx' instead of hiding
  let displayPriceStr = null;
  if (isPriceRange) {
    displayPriceStr = formatCurrency(lowestNum);
  } else if (mainPrice !== null && mainPrice > 0) {
    displayPriceStr = formatCurrency(mainPrice);
  } else if (isPackage) {
    // show RM prefix for package placeholders
    displayPriceStr = "xxxx";
  } else {
    // if no numeric price available and not a package, don't render the card
    return null;
  }

  const promoTags = product.promo_name
    ? product.promo_name
        .split(",")
        .map((tag) => tag.trim())
        .filter(Boolean)
    : [];

  const getPromoIcon = (tag) => {
    if (tag.toLowerCase().includes("free gift")) {
      return <FontAwesomeIcon icon={faGift} />;
    }
    if (tag.toLowerCase().includes("discount")) {
      return (
        <FallbackImg
          src={BadgePercent}
          alt="badgepercent"
          width="13"
          height="13"
          style={{
            filter:
              "invert(23%) sepia(13%) saturate(1162%) hue-rotate(54deg) brightness(93%) contrast(92%)",
          }}
        />
      );
    }
    if (tag.toLowerCase().includes("quantity offer")) {
      return <FontAwesomeIcon icon={faGift} />;
    }
    if (tag.toLowerCase().includes("pwp")) {
      return (
        <FallbackImg
          src={BadgePercent}
          alt="badgepercent"
          width="13"
          height="13"
          style={{
            filter:
              "invert(23%) sepia(13%) saturate(1162%) hue-rotate(54deg) brightness(93%) contrast(92%)",
          }}
        />
      );
    }
    return null;
  };

  // const sortedTags = [
  //   ...promoTags.filter((tag) => /^Buy \d+ Free \d+/i.test(tag)),
  //   ...promoTags.filter(
  //     (tag) =>
  //       tag.toLowerCase() !== "item discount" &&
  //       !/^Buy \d+ Free \d+/i.test(tag) &&
  //       tag.toLowerCase() !== "discount"
  //   ),
  //   ...promoTags.filter(
  //     (tag) =>
  //       tag.toLowerCase() === "item discount" ||
  //       tag.toLowerCase() === "discount"
  //   ),
  // ];

  // Merge all quantity offers into one tag
  // let quantityOffers = promoTags.filter((tag) =>
  //   /^Buy \d+ Free \d+/i.test(tag)
  // );
  // let otherTags = promoTags.filter((tag) => !/^Buy \d+ Free \d+/i.test(tag));

  // if (quantityOffers.length > 0) {
  //   otherTags = ["Quantity Offer", ...otherTags];
  // }

  // Regex to match all quantity offer patterns
  const isQuantityOffer = (tag) =>
    /^buy\s*\d+\s*(free|get)\s*\d+/i.test(tag) ||
    /^buy\s*\d+\s*(free|get)\s*\d+\s*discount/i.test(tag);

  // Filter and combine
  let hasQuantityOffer = promoTags.some(isQuantityOffer);
  let otherTags = promoTags.filter((tag) => !isQuantityOffer(tag));

  if (hasQuantityOffer) {
    otherTags = ["Quantity Offer", ...otherTags];
  }

  const sortedTags = [
    ...otherTags.filter(
      (tag) =>
        tag.toLowerCase() !== "item discount" &&
        tag.toLowerCase() !== "discount",
    ),
    ...otherTags.filter(
      (tag) =>
        tag.toLowerCase() === "item discount" ||
        tag.toLowerCase() === "discount",
    ),
  ];

  // Prepare category lines (split by '.') and reserve up to 3 lines
  const rawCategories = (product.selling_point || "")
    .split("|")
    .map((s) => s.trim())
    .filter(Boolean);
  const categoryLines = rawCategories.slice(0, 3);
  while (categoryLines.length < 3) categoryLines.push("");

  const getProductLink = (item) => {
    if (
      typeof item.item_id === "string" &&
      item.item_id.startsWith("is_package_")
    ) {
      const parts = item.item_id.split("_"); // ["is", "package", "13", "1"]
      const packageId = parts[2];
      const packageType = parts[3];

      if (packageType === "1") return `/grouppackagedetail/${packageId}`;
      if (packageType === "0") return `/packageproductdetail/${packageId}`;
    }

    if (item.bundle_id != null && item.bundle_id.includes("is_bundle")) {
      const bundleId = item.bundle_id.replace("is_bundle_", "");
      return `/productdetail/${item.item_id}?isBundle=1&bundleId=${bundleId}`;
    }

    return `/productdetail/${item.item_id}`;
  };

  return (
    <Link
      to={getProductLink(product)}
      style={{ textDecoration: "none" }}
      className="product-card2_v2"
    >
      <div className="product-card2-internal_v2">
        {/* promo overlay remains inside image container */}
        <div className="img-padding2_v2">
          {sortedTags.length > 0 && (
            <div className="promo-tag-overlay_v2">
              <span className="promo-tag-text_v2">Promo</span>
            </div>
          )}
          <FallbackImg
            src={product.item_photo_url}
            alt={product.item_code}
          />
        </div>

        {/* discount pill for poster should be outside image (card top-right) */}
        {showDiscount && discountPercent && (
          <div className="discount-pill_v2">{discountPercent}</div>
        )}

        <div className="product-card2-content_v2">
          <div className="product-card2-top_v2">
            <div className="product-card-name_v2" title={product.item_code}>
              {product.item_code}
            </div>
            <div className="product-card-descrip_v2" title={product.nickname}>
              {product.nickname}
            </div>
            <div className="productcategory_v2" title={product.selling_point}>
              <div className="productcategory-item_v2">{categoryLines[0]}</div>
              <div className="productcategory-item_v2">{categoryLines[1]}</div>
              <div className="productcategory-item_v2">{categoryLines[2]}</div>
            </div>
          </div>

          <div className="product-card2-bottom_v2">
            {displayPriceStr !== null && displayPriceStr !== "" && (
              <div className="product-card-price_v2">
                <span className="price-sub_v2">FROM</span> RM
                {displayPriceStr}
              </div>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default HomeBarSub2;
